// extracted by mini-css-extract-plugin
export default {"filterBadge":"FilterBadge_filterBadge__Jyrsv","filterBadgeLabel":"FilterBadge_filterBadgeLabel__ebBPn","filterBadgeRemove":"FilterBadge_filterBadgeRemove__Gw3dW"};